import { Injectable, inject } from '@angular/core';
import {
  BusinessProfile,
  BusinessProfileView,
  PersonalProfileSelectorView
} from '@com-delta-idp/mnx-capability-profile-selector-ui';
import { OauthAEMConfig } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  BUSINESS_TITLE,
  DOMAIN_PROD_URL,
  SKYBONUS_DEV_URL,
  SKYBONUS_PROD_URL
} from '../../constants/profile-selector-constants';
import {
  ProfileGroup,
  ProfileGroupType,
  ProfileTypes
} from '../../models/nuTravel.interface';
import { URL } from '../../models/profile-selector-aem.interface';
import { ProfileSelectorUtilService } from '../../utils/profile-selector-util.service';
@Injectable({
  providedIn: 'root'
})
export class SkyBonusNuTravelAdapterService {
  nuTravelObject = {} as ProfileTypes[];
  programUrl = {} as URL;
  businessProfileView = {} as BusinessProfileView;

  profileSelectorUtilService = inject(ProfileSelectorUtilService);

  transformNuTravelObject(
    personalProfileView: PersonalProfileSelectorView,
    businessProfileView: BusinessProfileView,
    url: URL,
    authConfig: OauthAEMConfig
  ): ProfileTypes[] {
    this.businessProfileView = businessProfileView;
    this.programUrl = url;
    const personalObject: ProfileTypes = this.transformPersonalObject(
      personalProfileView,
      authConfig
    );
    const businessObject: ProfileTypes = {
      profileCategory: businessProfileView.title,
      profileGroups: this.transformBusinessObject(businessProfileView)
    };

    this.nuTravelObject = [personalObject, businessObject];
    return [personalObject, businessObject];
  }

  getNuTravelObject(): ProfileTypes[] {
    return this.nuTravelObject;
  }

  setCompanySelected(name: string): void {
    const [, business] = this.getNuTravelObject();
    business.profileGroups.forEach((n) => {
      if (n.profileGroupName === name) {
        n.selectedProfile = true;
      } else {
        n.selectedProfile = false;
      }
    });
  }

  transformPersonalObject(
    data: PersonalProfileSelectorView,
    authConfig: OauthAEMConfig
  ): ProfileTypes {
    return {
      profileCategory: data.title,
      profileGroups: [
        {
          profileGroupName: data.displayName,
          redirectUrl: `${window.location.origin}${authConfig.LOGIN_STANDALONE_PAGE_URL}?fromAdmin=true&personal=true&companyName=${data.firstName}`
        }
      ]
    };
  }

  transformBusinessObject(data: BusinessProfileView): ProfileGroup[] {
    return data.businessProfile?.map((item) => {
      return {
        profileGroupName: item.displayName,
        redirectUrl: item.redirectUrl,
        profileAffiliatedId: item.userId,
        selectedProfile: false,
        profileGroupTypes: this.setProfileGroupTypes(item)
      };
    });
  }

  setProfileGroupTypes(data: BusinessProfile): ProfileGroupType[] {
    return data.permissionTypes.map((item) => {
      return {
        profileGroupTypeName: item.title,
        profileGroupGroupDescription: item.description,
        redirectUrl: this.setProfileGroupTypesRedirectUrl(
          item.title,
          data.displayName
        )
      };
    });
  }

  setProfileGroupTypesRedirectUrl(title: string, displayName: string): string {
    switch (title) {
      case BUSINESS_TITLE.BUSINESS_TRAVEL:
        return this.getBusinessTravelRedirectUrl(displayName);
      case BUSINESS_TITLE.MANAGE_TRAVEL_PROGRAM:
        return '';
      case BUSINESS_TITLE.SKYMILES_FOR_BUSINESS:
        return this.getSkyBonusPathUrl();
      default:
        return '';
    }
  }

  getSkyBonusPathUrl(): string {
    const environment = window.location.origin;
    if (environment === DOMAIN_PROD_URL) {
      return this.programUrl.permType_S ?? SKYBONUS_PROD_URL;
    } else {
      return this.programUrl.permType_S_Dev ?? SKYBONUS_DEV_URL;
    }
  }

  getBusinessTravelRedirectUrl(displayName: string): string {
    const match = this.businessProfileView.businessProfile?.find(
      (item) => item.displayName === displayName
    );
    return match?.redirectUrl ?? '';
  }
}
